import loading from '../resources/media/loading.svg';
import loadingDarkTheme from '../resources/media/loadingdarktheme.svg';
import React, { PureComponent } from 'react';
import { getCookie } from '../common/utils';

class Callback extends PureComponent {
    static displayName = 'Callback';

    render() {
        const themeCookie = getCookie('', 'theme-gateway');
        const bgColor = (themeCookie === 'dark')? '#060B12': this.props.bg;
        const loadingSvg = (themeCookie === 'dark') ? loadingDarkTheme : loading;
        const style = {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            height: '100vh',
            width: '100vw',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: `${bgColor}`,
        }

        return (
            <div id="callback-spin" style={style}>
                <img src={loadingSvg} alt="loading" style={{width: '100px'}}/>
            </div>
        );
    }
}

export default Callback;